import { type FC, type ReactNode } from 'react';
import {
  UiDrawer,
  UiDrawerOverlay,
  UiDrawerContent,
  UiDrawerBody,
  UiDrawerCloseButton,
  type UiDrawerProps,
} from '@/lib/ui';

export interface SmartWindowDrawerProps {
  isOpen: UiDrawerProps['isOpen']
  onClose: UiDrawerProps['onClose']
  children: ReactNode
}

const SmartWindowDrawer: FC<SmartWindowDrawerProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  return (
    <UiDrawer
      placement={'right'}
      size={'lg'}
      isOpen={isOpen}
      onClose={onClose}
    >
      <UiDrawerOverlay />
      <UiDrawerContent px={0}>
        <UiDrawerCloseButton size={'lg'} color={'primary.500'} />
        <UiDrawerBody bgColor={'gray.100'} alignItems={'stretch'} px={0}>
          {children}
        </UiDrawerBody>
      </UiDrawerContent>
    </UiDrawer>
  );
};

export default SmartWindowDrawer;
